import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/ui/loaders';

// ------- SAGA ------ //

function verificacionLoader(state, action) {
  const { isLoading } = action.payload;
  state.isLoaderVerificar = isLoading;
}

function changeStatusLoaderOferta(state, action) {
  const { isLoading } = action.payload;
  state.isLoaderOferta = isLoading;
}

function changeStatusLoaderEncuesta(state, action) {
  const { isLoading } = action.payload;
  state.isLoadingEncuesta = isLoading;
}

// function changeStatusLoaderValidar(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderValidar = isLoading;
// }

// function changeStatusLoaderValidarTcoo(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderValidarTcco = isLoading;
// }

// function changeStatusLoaderSesion(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderSesion = isLoading;
// }

// function changeStatusLoaderInformar(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderInformar = isLoading;
// }

// function changeStatusObtener(state, action) {
//   const { isLoading } = action.payload;
//   state.loaderObtener = isLoading;
// }


const loaderGeneral = createAction('loaderGeneral');


const loadersReducer = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    verificacionLoader,
    changeStatusLoaderOferta,
    changeStatusLoaderEncuesta
  },
});

export const loadersActions = {
  ...loadersReducer.actions,
  loaderGeneral
};

export default loadersReducer.reducer;
